import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useData } from "../../components/toast/Api";

interface OrderData {
  orderNumber: string;
  paymenton: string;
  ordertotal: number;
  paymentMode: string;
  paymentstatus: number;
  NoofApplications: number;
}

const Skeleton = () => (
  <section className="thank-you-wrapper">
    <div className="background-logo skeleton-background-logo"></div>
    <div className="thank-you-container">
      <header className="thank-you-header">
        <h1 className="thank-you-title skeleton-title"></h1>
        <p className="thank-you-subtitle skeleton-subtitle"></p>
      </header>
      <section className="thank-you-details">
        <h2 className="details-title skeleton-details-title"></h2>
        <div className="details-card">
          <ul className="details-list">
            <li className="details-item skeleton-details-item"></li>
            <li className="details-item skeleton-details-item"></li>
            <li className="details-item skeleton-details-item"></li>
            <li className="details-item skeleton-details-item"></li>
            <li className="details-item skeleton-details-item"></li>
            <li className="details-item skeleton-details-item"></li>
          </ul>
        </div>
      </section>
      <footer className="thank-you-footer">
        <p className="footer-text skeleton-footer-text"></p>
        <a href="/" className="footer-button skeleton-footer-button"></a>
        <p className="skeleton-redirecting"></p>
      </footer>
    </div>
  </section>
);

const Thankyou: React.FC = () => {
  const { showError } = useData();
  const location = useLocation();
  const navigate = useNavigate();

  const [orderData, setOrderData] = useState<OrderData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error] = useState(null);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const ref = searchParams.get("ref");

    const fetchData = async () => {
      try {
        if (ref) {
          const response = await fetch(
            `${import.meta.env.VITE_API_URL}/api/payment/redirectUrl?ref=${ref}`
          );

          if (response.status === 400) {
            showError("Payment Decline");
            navigate("/payment");
            return;
          }
          if (!response.ok) throw new Error("Network error");

          const data = await response.json();
          setOrderData(data.result2);
        } else {
          const orderNumber = localStorage.getItem("orderNumber");
          if (!orderNumber) return;

          const parsedOrder = JSON.parse(orderNumber);
          const response = await fetch(
            `${import.meta.env.VITE_API_URL}/api/payment/redirectUrlCash?orderNumber=${parsedOrder}`
          );

          if (!response.ok) throw new Error("Network error");

          const data = await response.json();
          setOrderData(data.result);
        }

        setLoading(false);
      } catch (err) {
        setLoading(false);
      }
    };

    fetchData();
  }, [location, navigate, showError]);

  useEffect(() => {
    if (error) {
      navigate("/");
    }
  }, [error, navigate]);

  if (!loading) return <Skeleton />;
  return (
    <div>
      <div
        className="thank-you-wrap d-flex flex-column align-items-center justify-content-center col-md-4 mx-auto gap-3 col-11 h-100 mt-5 pt-5"
        style={{ minHeight: "100vh" }}
      >
        <div>
          <img
            src="https://goodhand.b-cdn.net/Assets/Upload/sucsess-animate.svg"
            alt=""
          />
        </div>

        <div className="bg-2 font-14 px-3 py-2 rounded-3 d-flex flex-column align-items-center justify-content-center text-center gap-2 w-100">
          <p className="ff-bold font-16 mb-1">Thank you for your order!</p>
          <p className="font-14 ff-medium">
            Your application is now being processed and your documents are under
            verification.
          </p>
        </div>
        <div>
          <svg width="100%" height="1" viewBox="0 0 600 1" fill="none" xmlns="http://www.w3.org/2000/svg">
            <line y1="0.583374" x2="600" y2="0.583374" stroke="#C3C3C3" strokeWidth="0.5" stroke-dasharray="6 6"/>
          </svg>
        </div>

        <div>
          <p className="font-21 ff-semibold text-black mb-0">Your Order Summery</p>
        </div>
        <div className="rounded-4 border p-3 w-100" style={{ backgroundColor: "#ffffff", boxShadow: "0 0 0 rgba(0,0,0,0.05)" }}>
          <div className="d-flex justify-content-between border-dashed pb-2 mb-2 ff-medium font-14 text-black">
            <span>Date</span>
            <span>{orderData?.paymenton ? new Date(orderData.paymenton).toLocaleDateString() : ""}</span>
          </div>
          <div className="d-flex justify-content-between border-dashed  pb-2 mb-2  ff-medium font-14 text-black">
            <span>Order No</span>
            <span>
              <a href="#" className="text-decoration-none text-primary ff-bold">
                {orderData?.orderNumber}
              </a>
            </span>
          </div>
          <div className="d-flex justify-content-between border-dashed  pb-2 mb-3 ff-medium font-14 text-black">
            <span className="text-muted">Mod Of Payment</span>
            <span className="d-flex align-items-center gap-2">
              <img src="https://goodhand.b-cdn.net/Assets/Upload/viss.png" alt="Visa" width="30" height="18" />
              <span>{orderData?.paymentMode}</span>
            </span>
          </div>
          <div className="d-flex justify-content-between border-dashed  pb-2 mb-3 ff-medium font-14 text-black">
            <span className="text-muted">Payment Status</span>
            <span>{orderData?.paymentstatus === 1 ? "Paid" : "Pending"}</span>
          </div>
          <div className="d-flex justify-content-between border-dashed  pb-2 mb-3 ff-medium font-14 text-black">
            <span className="text-muted">No. of Applications</span>
            <span>{orderData?.NoofApplications}</span>
          </div>
          <div className="d-flex justify-content-between pt-2">
            <strong>Paid Amount</strong>
            <strong>{orderData?.ordertotal}</strong>
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-between gap-3 text-center my-4 w-100">
          {/* Explore More Services Button */}
          <label className="w-100 px-3 py-2 rounded-3 bg-primary ff-medium d-flex align-items-center justify-content-center gap-2 cursor-pointer" style={{ marginBottom: 0 }} >
            <div>
              <img src="https://goodhand.b-cdn.net/Assets/Upload/home-til.svg" alt="Home Icon" />
            </div>
            <p className="mb-0 text-white font-13">Explore more services</p>
            <input type="file" className="hidden-inputt" accept=".jpg,.png,.pdf" hidden />
          </label>

          {/* Track Order Button */}
          <div className="w-100">
            <div className="bg-dark px-3 py-2 rounded-3 ff-medium d-flex align-items-center justify-content-center gap-2 cursor-pointer">
              <div>
                <img src="https://goodhand.b-cdn.net/Assets/Upload/arrow-til.svg" alt="Arrow Icon" />
              </div>
              <span className="d-block font-13 ff-semibold text-white">Track order</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Thankyou;
